import Roles from '@/auth/roles';
import ManagerForm from './referee-form';
import ManagerList from './referee-list';
import ManagerHistoryFull from './referee-history/referee-history-full/referee-history-full';
import ManagerHistorySingle from './referee-history/referee-history-single/referee-history-single';
import ManagerShow from './referee-show';

const roles = Roles.values;

export default [
  {
    name: 'refereeList',
    path: 'referee',
    component: ManagerList,
    meta: {
      auth: true,
      roles: [
        roles.owner.id,
        roles.activityViewer.id,
        roles.entityViewer.id,
        roles.entityEditor.id,
        roles.refereeViewer.id,
        roles.refereeEditor.id
      ]
    }
  },
  {
    name: 'refereeNew',
    path: 'referee/new',
    component: ManagerForm,
    meta: {
      auth: true,
      roles: [
        roles.owner.id,
        roles.entityEditor.id,
        roles.refereeEditor.id
      ]
    }
  },
  {
    name: 'refereeEdit',
    path: 'referee/:id/edit',
    component: ManagerForm,
    props: true,
    meta: {
      auth: true,
      roles: [
        roles.owner.id,
        roles.entityEditor.id,
        roles.refereeEditor.id
      ]
    }
  },
  {
    name: 'refereeHistorySingle',
    path: 'referee/:id/history',
    component: ManagerHistorySingle,
    props: true,
    meta: {
      auth: true,
      roles: [roles.owner.id, roles.activityViewer.id]
    }
  },
  {
    name: 'refereeHistoryFull',
    path: 'referee/history',
    component: ManagerHistoryFull,
    meta: {
      auth: true,
      roles: [roles.owner.id, roles.activityViewer.id]
    }
  },
  {
    name: 'refereeShow',
    path: 'referee/:id',
    component: ManagerShow,
    props: true,
    meta: {
      auth: true,
      roles: [
        roles.owner.id,
        roles.activityViewer.id,
        roles.entityViewer.id,
        roles.entityEditor.id,
        roles.refereeViewer.id,
        roles.refereeEditor.id
      ]
    }
  }
];



// WEBPACK FOOTER //
// ./src/entities/referee/referee-routes.js